// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';  // Ensure AuthProvider is correctly imported

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <AuthProvider>   {/* Wrap App with AuthProvider */}
      <App />
    </AuthProvider>
  // </React.StrictMode>
);
